import { useState } from "react";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      toast.success("Iscrizione confermata! Il prossimo Biscotto della Settimana arriverà via email.");
      setEmail("");
    } catch {
      toast.error("Qualcosa è andato storto. Riprova tra poco!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Reveal>
      <div
        data-testid="newsletter-section"
        className="relative mt-16 overflow-hidden rounded-[2rem] border border-pink-100 bg-white p-8 text-center sm:p-10"
      >
        <div className="spotlight pointer-events-none absolute inset-0" />
        <div className="relative mx-auto max-w-md">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-blush">
            <Mail className="h-5 w-5 text-rosa-dark" />
          </span>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-cacao">
            Ricevi il Biscotto della Settimana
          </h2>
          <p className="mt-2 text-sm text-cacao-muted leading-relaxed">
            Lascia la tua email: ogni settimana un nuovo personaggio da
            creare, direttamente nella tua casella di posta.
          </p>
          <form onSubmit={submit} className="mt-6 flex flex-col gap-3 sm:flex-row">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="la-tua@email.it"
              data-testid="newsletter-email-input"
              className="flex-1 rounded-full border border-pink-200 bg-crema px-5 py-3 text-sm text-cacao outline-none transition-colors placeholder:text-cacao-light focus:border-rosa"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-rosa px-6 py-3 text-sm font-bold text-white shadow-[0_10px_30px_rgba(232,122,144,0.4)] transition-colors hover:bg-rosa-dark disabled:opacity-60"
            >
              <Send className="h-4 w-4" />
              {loading ? "Invio..." : "Iscriviti"}
            </button>
          </form>
          <p className="mt-3 text-[11px] text-cacao-light">
            Niente spam, solo dolcezza. Potrai cancellarti quando vuoi.
          </p>
        </div>
      </div>
    </Reveal>
  );
};

export default Newsletter;
